export const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
})

function hexToRgb(hex: string): { r: number, g: number, b: number } | null {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
  return result
    ? {
        r: Number.parseInt(result[1], 16),
        g: Number.parseInt(result[2], 16),
        b: Number.parseInt(result[3], 16),
      }
    : null
}

export function cssvar(name: string, opacity?: number): string {
  const computedVariable = getComputedStyle(document.getElementById('cd-widget-credit-overview')!).getPropertyValue(name)

  if (opacity) {
    const rgb = hexToRgb(computedVariable.trim().slice(1))

    if (rgb)
      return `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${opacity})`
  }

  return computedVariable
}
